import { useState } from 'react'
import { api } from '../api.js'
import Layout from '../componentes/Layout.jsx'
import {
  useDados, Campo, Erro, Carregando, emReais, emKm, emDataSimples,
} from '../componentes/basicos.jsx'

const CATEGORIAS = ['seguro', 'ipva', 'licenciamento', 'outros']
const hoje = () => new Date().toISOString().slice(0, 10)

export default function Registros() {
  const [aba, setAba] = useState('manutencoes')

  return (
    <Layout titulo="Manutenções e despesas">
      <div className="chips" role="tablist">
        <button type="button" className="chip" aria-pressed={aba === 'manutencoes'}
                onClick={() => setAba('manutencoes')}>Manutenções</button>
        <button type="button" className="chip" aria-pressed={aba === 'despesas'}
                onClick={() => setAba('despesas')}>Despesas</button>
      </div>

      {aba === 'manutencoes' ? <Manutencoes /> : <Despesas />}
    </Layout>
  )
}

function SeletorVeiculo({ veiculos, valor, aoMudar }) {
  if (veiculos.length <= 1) return null
  return (
    <Campo rotulo="Veículo">
      <select value={valor} onChange={(e) => aoMudar(e.target.value)}>
        {veiculos.map((v) => <option key={v.id} value={v.id}>{v.nome}</option>)}
      </select>
    </Campo>
  )
}

function Manutencoes() {
  const { dados: garagem } = useDados('/veiculos')
  const { dados, carregando, recarregar } = useDados('/manutencoes')
  const veiculos = garagem?.veiculos ?? []

  const vazio = {
    veiculo_id: '', data: hoje(), tipo: '', descricao: '', custo: '',
    odometro: '', oficina: '', proxima_km: '', proxima_data: '',
  }
  const [form, setForm] = useState(vazio)
  const [erro, setErro] = useState(null)
  const [editando, setEditando] = useState(null)

  async function criar(evento) {
    evento.preventDefault()
    setErro(null)
    try {
      await api.post('/manutencoes', {
        veiculo_id: Number(form.veiculo_id || veiculos[0]?.id),
        data: form.data,
        tipo: form.tipo,
        descricao: form.descricao || null,
        custo: Number(String(form.custo || 0).replace(',', '.')),
        odometro: form.odometro ? Number(form.odometro) : null,
        oficina: form.oficina || null,
        proxima_km: form.proxima_km ? Number(form.proxima_km) : null,
        proxima_data: form.proxima_data || null,
      })
      setForm(vazio)
      await recarregar()
    } catch (e) {
      setErro(e)
    }
  }

  if (carregando) return <Carregando />

  return (
    <div className="colunas-desktop">
      {dados.manutencoes.length > 0 && (
        <section className="cartao">
          <ul className="lista">
            {dados.manutencoes.map((m) => (
              <li key={m.id}>
                <div className="entre">
                  <div>
                    <div className="titulo-item">{m.tipo} · {emReais(m.custo)}</div>
                    <div className="detalhe">
                      {emDataSimples(m.data)}
                      {m.odometro && ` · ${emKm(m.odometro)}`}
                      {m.oficina && ` · ${m.oficina}`}
                      {m.proxima_km && ` · próxima em ${emKm(m.proxima_km)}`}
                      {m.proxima_data && ` · próxima em ${emDataSimples(m.proxima_data)}`}
                    </div>
                  </div>
                  <div className="linha" style={{ flexWrap: 'nowrap' }}>
                    <button type="button" className="botao-fantasma"
                            onClick={() => setEditando(editando === m.id ? null : m.id)}>
                      {editando === m.id ? 'Fechar' : 'Editar'}
                    </button>
                    <button type="button" className="botao-perigo"
                            onClick={async () => { await api.remover(`/manutencoes/${m.id}`); recarregar() }}>
                      Excluir
                    </button>
                  </div>
                </div>

                {editando === m.id && (
                  <EditarManutencao manutencao={m}
                                    aoSalvar={async () => { setEditando(null); await recarregar() }} />
                )}
              </li>
            ))}
          </ul>
        </section>
      )}

      <form className="cartao pilha" onSubmit={criar}>
        <span className="rotulo-secao">Nova manutenção</span>
        <SeletorVeiculo veiculos={veiculos} valor={form.veiculo_id}
                        aoMudar={(v) => setForm({ ...form, veiculo_id: v })} />

        <Campo rotulo="O que foi feito">
          <input value={form.tipo} required placeholder="Troca de óleo, revisão…"
                 onChange={(e) => setForm({ ...form, tipo: e.target.value })} />
        </Campo>

        <div className="linha">
          <div className="crescer">
            <Campo rotulo="Data">
              <input type="date" value={form.data} required
                     onChange={(e) => setForm({ ...form, data: e.target.value })} />
            </Campo>
          </div>
          <div className="crescer">
            <Campo rotulo="Custo (R$)">
              <input inputMode="decimal" value={form.custo}
                     onChange={(e) => setForm({ ...form, custo: e.target.value })} />
            </Campo>
          </div>
        </div>

        <Campo rotulo="Odômetro (km)">
          <input inputMode="numeric" value={form.odometro}
                 onChange={(e) => setForm({ ...form, odometro: e.target.value })} />
        </Campo>

        <details>
          <summary style={{ padding: '8px 0', cursor: 'pointer', color: 'var(--tinta-2)' }}>
            Agendar próxima
          </summary>
          <div className="pilha" style={{ marginTop: 8 }}>
            <Campo rotulo="Próxima em (km)" dica="Vira lembrete quando o odômetro se aproximar.">
              <input inputMode="numeric" value={form.proxima_km}
                     onChange={(e) => setForm({ ...form, proxima_km: e.target.value })} />
            </Campo>
            <Campo rotulo="Próxima data">
              <input type="date" value={form.proxima_data}
                     onChange={(e) => setForm({ ...form, proxima_data: e.target.value })} />
            </Campo>
            <Campo rotulo="Oficina">
              <input value={form.oficina} onChange={(e) => setForm({ ...form, oficina: e.target.value })} />
            </Campo>
          </div>
        </details>

        <Erro erro={erro} />
        <button type="submit" className="botao-principal botao-largo">Registrar</button>
      </form>
    </div>
  )
}

const paraNumero = (t) => (t === '' || t === null ? null : Number(String(t).replace(',', '.')))

function EditarManutencao({ manutencao: m, aoSalvar }) {
  const [form, setForm] = useState({
    data: m.data,
    tipo: m.tipo,
    descricao: m.descricao ?? '',
    custo: String(m.custo),
    odometro: m.odometro ?? '',
    oficina: m.oficina ?? '',
    proxima_km: m.proxima_km ?? '',
    proxima_data: m.proxima_data ?? '',
  })
  const [erro, setErro] = useState(null)
  const [salvando, setSalvando] = useState(false)

  async function salvar(evento) {
    evento.preventDefault()
    setSalvando(true)
    setErro(null)
    try {
      await api.patch(`/manutencoes/${m.id}`, {
        data: form.data,
        tipo: form.tipo,
        descricao: form.descricao || null,
        custo: paraNumero(form.custo) ?? 0,
        odometro: paraNumero(form.odometro),
        oficina: form.oficina || null,
        proxima_km: paraNumero(form.proxima_km),
        proxima_data: form.proxima_data || null,
      })
      await aoSalvar()
    } catch (e) {
      setErro(e)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <form className="pilha" style={{ marginTop: 12 }} onSubmit={salvar}>
      <Campo rotulo="O que foi feito">
        <input value={form.tipo} required onChange={(e) => setForm({ ...form, tipo: e.target.value })} />
      </Campo>

      <div className="linha">
        <div className="crescer">
          <Campo rotulo="Data">
            <input type="date" value={form.data} required
                   onChange={(e) => setForm({ ...form, data: e.target.value })} />
          </Campo>
        </div>
        <div className="crescer">
          <Campo rotulo="Custo (R$)">
            <input inputMode="decimal" value={form.custo}
                   onChange={(e) => setForm({ ...form, custo: e.target.value })} />
          </Campo>
        </div>
      </div>

      <Campo rotulo="Odômetro (km)">
        <input inputMode="numeric" value={form.odometro}
               onChange={(e) => setForm({ ...form, odometro: e.target.value })} />
      </Campo>

      <Campo rotulo="Oficina">
        <input value={form.oficina} onChange={(e) => setForm({ ...form, oficina: e.target.value })} />
      </Campo>

      <Campo rotulo="Próxima em (km)">
        <input inputMode="numeric" value={form.proxima_km}
               onChange={(e) => setForm({ ...form, proxima_km: e.target.value })} />
      </Campo>

      <Campo rotulo="Próxima data">
        <input type="date" value={form.proxima_data}
               onChange={(e) => setForm({ ...form, proxima_data: e.target.value })} />
      </Campo>

      <Erro erro={erro} />
      <button type="submit" className="botao-principal botao-largo" disabled={salvando}>
        {salvando ? 'Salvando…' : 'Salvar alterações'}
      </button>
    </form>
  )
}

function EditarDespesa({ despesa: d, aoSalvar }) {
  const [form, setForm] = useState({
    data: d.data,
    categoria: d.categoria,
    descricao: d.descricao ?? '',
    custo: String(d.custo),
    recorrente: d.recorrente ?? '',
    proximo_vencimento: d.proximo_vencimento ?? '',
  })
  const [erro, setErro] = useState(null)
  const [salvando, setSalvando] = useState(false)

  async function salvar(evento) {
    evento.preventDefault()
    setSalvando(true)
    setErro(null)
    try {
      await api.patch(`/despesas/${d.id}`, {
        data: form.data,
        categoria: form.categoria,
        descricao: form.descricao || null,
        custo: paraNumero(form.custo) ?? 0,
        recorrente: form.recorrente || null,
        proximo_vencimento: form.proximo_vencimento || null,
      })
      await aoSalvar()
    } catch (e) {
      setErro(e)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <form className="pilha" style={{ marginTop: 12 }} onSubmit={salvar}>
      <Campo rotulo="Categoria">
        <select value={form.categoria}
                onChange={(e) => setForm({ ...form, categoria: e.target.value })}>
          {CATEGORIAS.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </Campo>

      <div className="linha">
        <div className="crescer">
          <Campo rotulo="Data">
            <input type="date" value={form.data} required
                   onChange={(e) => setForm({ ...form, data: e.target.value })} />
          </Campo>
        </div>
        <div className="crescer">
          <Campo rotulo="Custo (R$)">
            <input inputMode="decimal" value={form.custo}
                   onChange={(e) => setForm({ ...form, custo: e.target.value })} />
          </Campo>
        </div>
      </div>

      <Campo rotulo="Próximo vencimento">
        <input type="date" value={form.proximo_vencimento}
               onChange={(e) => setForm({ ...form, proximo_vencimento: e.target.value })} />
      </Campo>

      <Campo rotulo="Descrição">
        <input value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </Campo>

      <Erro erro={erro} />
      <button type="submit" className="botao-principal botao-largo" disabled={salvando}>
        {salvando ? 'Salvando…' : 'Salvar alterações'}
      </button>
    </form>
  )
}

function Despesas() {
  const { dados: garagem } = useDados('/veiculos')
  const { dados, carregando, recarregar } = useDados('/despesas')
  const veiculos = garagem?.veiculos ?? []

  const vazio = {
    veiculo_id: '', data: hoje(), categoria: 'ipva', descricao: '', custo: '',
    recorrente: '', proximo_vencimento: '',
  }
  const [form, setForm] = useState(vazio)
  const [erro, setErro] = useState(null)
  const [editando, setEditando] = useState(null)

  async function criar(evento) {
    evento.preventDefault()
    setErro(null)
    try {
      await api.post('/despesas', {
        veiculo_id: Number(form.veiculo_id || veiculos[0]?.id),
        data: form.data,
        categoria: form.categoria,
        descricao: form.descricao || null,
        custo: Number(String(form.custo || 0).replace(',', '.')),
        recorrente: form.recorrente || null,
        proximo_vencimento: form.proximo_vencimento || null,
      })
      setForm(vazio)
      await recarregar()
    } catch (e) {
      setErro(e)
    }
  }

  if (carregando) return <Carregando />

  return (
    <div className="colunas-desktop">
      {dados.despesas.length > 0 && (
        <section className="cartao">
          <ul className="lista">
            {dados.despesas.map((d) => (
              <li key={d.id}>
                <div className="entre">
                  <div>
                    <div className="titulo-item">{d.categoria} · {emReais(d.custo)}</div>
                    <div className="detalhe">
                      {emDataSimples(d.data)}
                      {d.descricao && ` · ${d.descricao}`}
                      {d.proximo_vencimento && ` · vence ${emDataSimples(d.proximo_vencimento)}`}
                    </div>
                  </div>
                  <div className="linha" style={{ flexWrap: 'nowrap' }}>
                    <button type="button" className="botao-fantasma"
                            onClick={() => setEditando(editando === d.id ? null : d.id)}>
                      {editando === d.id ? 'Fechar' : 'Editar'}
                    </button>
                    <button type="button" className="botao-perigo"
                            onClick={async () => { await api.remover(`/despesas/${d.id}`); recarregar() }}>
                      Excluir
                    </button>
                  </div>
                </div>

                {editando === d.id && (
                  <EditarDespesa despesa={d}
                                 aoSalvar={async () => { setEditando(null); await recarregar() }} />
                )}
              </li>
            ))}
          </ul>
        </section>
      )}

      <form className="cartao pilha" onSubmit={criar}>
        <span className="rotulo-secao">Nova despesa</span>
        <SeletorVeiculo veiculos={veiculos} valor={form.veiculo_id}
                        aoMudar={(v) => setForm({ ...form, veiculo_id: v })} />

        <Campo rotulo="Categoria">
          <select value={form.categoria} onChange={(e) => setForm({ ...form, categoria: e.target.value })}>
            {CATEGORIAS.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </Campo>

        <div className="linha">
          <div className="crescer">
            <Campo rotulo="Data">
              <input type="date" value={form.data} required
                     onChange={(e) => setForm({ ...form, data: e.target.value })} />
            </Campo>
          </div>
          <div className="crescer">
            <Campo rotulo="Custo (R$)">
              <input inputMode="decimal" value={form.custo}
                     onChange={(e) => setForm({ ...form, custo: e.target.value })} />
            </Campo>
          </div>
        </div>

        <Campo rotulo="Próximo vencimento" dica="Vira lembrete quando a data se aproximar.">
          <input type="date" value={form.proximo_vencimento}
                 onChange={(e) => setForm({ ...form, proximo_vencimento: e.target.value })} />
        </Campo>

        <Campo rotulo="Descrição">
          <input value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
        </Campo>

        <Erro erro={erro} />
        <button type="submit" className="botao-principal botao-largo">Registrar</button>
      </form>
    </div>
  )
}
